import { sortTimeListFunc } from '@op/utils';
import { resolveOpinionChartXAxisValue } from './resolveOpinionChartXAxisValue';
import { getOpinionEventOnlyOneKey } from './buildEventSettingSelectValue';
import { normalizeOpinionDateType } from './getTimelineTimeFormat';

interface IBuildBubbleEventFromSelectedKeysOptions {
  xAxisData?: string[];
  dateType?: string;
  timeFormat?: string;
}

/** 按事件设置勾选项重建 bubbleEvent */
export function buildBubbleEventFromSelectedKeys(
  eventList: Record<string, any[]>,
  selectedEventKeys: Record<string, string[]>,
  options: IBuildBubbleEventFromSelectedKeysOptions = {},
): Record<string, any[]> {
  const selectedList = Object.values(selectedEventKeys || {}).flat();
  const normalizedDateType = normalizeOpinionDateType(options.dateType);
  const timeFormat = options.timeFormat || 'YYYY-MM-DD';
  const xAxisData = options.xAxisData || [];

  const list = Object.values(eventList || {})
    .flat()
    .filter(item =>
      selectedList.includes(getOpinionEventOnlyOneKey(item)),
    );

  list.sort(sortTimeListFunc('start_time', 'desc'));
  const result: Record<string, any[]> = {};

  list.forEach(item => {
    const { realValue: time } = resolveOpinionChartXAxisValue(
      item.start_time,
      normalizedDateType,
      timeFormat,
      xAxisData,
    );
    if (!result[time]) {
      result[time] = [];
    }
    result[time].push(item);
  });

  return result;
}
